<template>
  <div class="home">
    <div class="wrapper-content">
      <div class="breadcrumb_box">
        <div class="container-fluid">
          <h2>Edit Profile</h2>
        </div>
      </div>

      <div class="addmoney newaddress">
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <div class="add-newaddresss panel">
                <h2>Edit Profile</h2>
                <div class="profile-edit-photo">
                  <div class="round-profile">
                    <img src="../assets/images/dessert.png" alt="logo" />
                  </div>
                  <input type="file" name="myFile" multiple class="upload-images" />
                  <img
                    src="../assets/images/plus.png"
                    class="upload-imageinline"
                    alt="upload-images"
                  />
                </div>
                <form class="input-animation">
                  <div class="input-field">
                    <input type="text" id="name" v-model="name" required />
                    <label for="name">Full Name</label>
                  </div>
                  <div class="input-field">
                    <input type="text" id="email" v-model="email" required />
                    <label for="email">Email Address</label>
                  </div>
                  <div class="input-field">
                    <input type="text" id="appartment" v-model="houseNo" required />
                    <label for="appartment">Apartment Name/House No./Flat No</label>
                  </div>
                  <div class="input-field" v-b-modal.map>
                    <input type="text" id="local" v-model="locality" required />
                    <label for="local">Location</label>
                    <img class="svg" src="../assets/images/maps-and-flags.svg" alt="map" />
                  </div>
                  <div class="input-field">
                    <input type="text" id="state" v-model="state" required />
                    <label for="state">State</label>
                  </div>

                  <div class="input-field">
                    <input type="text" id="city" v-model="city" required />
                    <label for="city">City</label>
                  </div>

                  <div class="input-field">
                    <input type="text" id="zip" v-model="zipcode" required />
                    <label for="zip">Zip Code</label>
                  </div>

                  <div class="input-field">
                    <input type="text" id="land" v-model="landMark" required />
                    <label for="land">Landmark</label>
                  </div>

                  <!-- <div class="form-group">
                    <label class="normalLabel">Nickname For Address</label>
                    <Ul class="radioBtnsFlat">
                      <li>
                        <input type="radio" name="NicknameAddress" id="home" checked />
                        <label for="home">Home</label>
                      </li>
                      <li>
                        <input type="radio" name="NicknameAddress" id="work" />
                        <label for="work">Work</label>
                      </li>
                      <li>
                        <input type="radio" name="NicknameAddress" id="other" />
                        <label for="other">Others</label>
                      </li>
                    </Ul>
                  </div>-->
                  <div class="input-field">
                    <b-form-group label="Nickname For Address">
                      <b-form-radio-group
                        id="btn-radios-2"
                        v-model="selected"
                        :options="options"
                        buttons
                        button-variant="outline-dark"
                        size="lg"
                        name="radio-btn-outline"
                      ></b-form-radio-group>
                    </b-form-group>
                  </div>
                  <button class="submit-btn" v-on:click="getregistered">Update</button>
                </form>
                <b-modal id="map" title="Select Location" ok-only>
                  <gmap-autocomplete @place_changed="setPlace" class="mb-1"></gmap-autocomplete>

                  <gmap-map :center="center" :zoom="12" style="width:100%;  height: 400px;">
                    <gmap-marker :position="center" @drag="updateCoordinates" :draggable="true"></gmap-marker>
                  </gmap-map>
                </b-modal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { getProfileDetails, registerProfile } from "./../services/api";
import VueGeolocation from "vue-browser-geolocation";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
const axios = require("axios");
Vue.use(VueGeolocation);
export default {
  name: "home",
  components: { Loading },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      options: [
        { text: "Home", value: "home" },
        { text: "Work", value: "work" },
        { text: "Other", value: "other" }
      ],
      selected: "",
      lat: "",
      long: "",
      profile_details: "",
      profile: "",
      name: "",
      email: "",
      houseNo: "",
      state: "",
      city: "",
      zipcode: "",
      locality: "",
      landMark: "",
      center: {
        lat: "",
        lng: ""
      },
      markers: [],
      places: [],
      currentPlace: null
    };
  },
  created() {
    this.getProfile();
    this.geolocate();
  },
  methods: {
    getProfile() {
      var requestData = {
        user_id: localStorage.getItem("userId"),
        token: localStorage.getItem("token"),
        vendor_id: localStorage.getItem("vendorId")
      };
      // this.isLoading = true;
      getProfileDetails(requestData)
        .then(result => {
          if (result.data.successCode === 1) {
            this.profile = result.data;
            this.profile_details = result.data.profile;
            this.name = result.data.profile.name;
            this.email = result.data.profile.email_id;
            this.houseNo = result.data.profile.houseNo;
            this.state = result.data.profile.state;
            this.city = result.data.profile.city;
            this.zipcode = result.data.profile.zipcode;
            this.locality = result.data.profile.locality;
            this.landMark = result.data.profile.landMark;
            this.selected = result.data.profile.title;
            console.log("dd", result);
            this.isLoading = false;
          } else if (
            result.data.successCode === 0 &&
            result.data.messageCode === 1053
          ) {
            localStorage.clear();
            this.$router.replace({ name: "register" });
            this.isLoading = false;
          }
        })
        .catch(error => {
          // this.isLoading = false;
          return;
        });
    },
    getregistered() {
      var requestData = {
        user_id: localStorage.getItem("userId"),
        token: localStorage.getItem("token"),
        area_id: 0,
        region_id: 0,
        name: this.name,
        email: this.email,
        address: this.locality,
        location: this.locality,
        lat: this.lat,
        lng: this.long,
        landMark: this.landmark,
        areaCode: this.zipCode,
        state: this.state,
        title: this.selected,
        city: this.city,
        vendor_id: localStorage.getItem("vendorId")
      };

      registerProfile(requestData)
        .then(result => {
          if (result.data.successCode === 1) {
            // this.$router.push("/home");
          }
        })
        .catch(error => {
          return;
        });
    },
    updateCoordinates(location) {
      this.lat = location.latLng.lat();
      this.long = location.latLng.lng();

      this.getStreetAddressFrom(this.lat, this.long);
    },
    setPlace(place) {
      this.currentPlace = place;
    },
    addMarker() {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        };
        this.markers.push({ position: marker });
        this.places.push(this.currentPlace);
        this.center = marker;
        this.currentPlace = null;
      }
    },

    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        if (position.coords.latitude) {
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          this.getStreetAddressFrom(
            position.coords.latitude,
            position.coords.longitude
          );
        } else {
          this.center = {
            lat: 30.679948,
            lng: 76.726951
          };
        }
      });
    },

    async getStreetAddressFrom(lat, long) {
      try {
        var { data } = await axios.get(
          "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
            lat +
            "," +
            long +
            "&key=" +
            this.key
        );

        if (data.error_message) {
        } else {
          this.locality = data.results[0].formatted_address;

          for (var i = 0; i < data.results[0].address_components.length; i++) {
            for (
              var b = 0;
              b < data.results[0].address_components[i].types.length;
              b++
            ) {
              if (
                data.results[0].address_components[i].types[b] ==
                "administrative_area_level_1"
              ) {
                this.state = data.results[0].address_components[i].long_name;

                break;
              }

              if (
                data.results[0].address_components[i].types[b] ==
                "administrative_area_level_2"
              ) {
                this.city = data.results[0].address_components[i].long_name;

                break;
              }
              if (
                data.results[0].address_components[i].types[b] == "postal_code"
              ) {
                this.zipCode = data.results[0].address_components[i].long_name;

                break;
              }
              if (
                data.results[0].address_components[i].types[b] ==
                "street_number"
              ) {
                this.houseNo = data.results[0].address_components[i].long_name;

                break;
              }
            }
          }
        }
      } catch (error) {}
    }
  }
};
</script>
